import { render, staticRenderFns } from "./DeceasedSearch.vue?vue&type=template&id=2b6d4cfc&"
import script from "./DeceasedSearch.vue?vue&type=script&lang=js&"
export * from "./DeceasedSearch.vue?vue&type=script&lang=js&"
import style0 from "./DeceasedSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports